'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var IntegrationButton = exports.IntegrationButton = undefined;

exports.IntegrationButton = IntegrationButton = function IntegrationButton(refs, _ref) {
    var isDefaultButton = _ref.isDefaultButton,
        objectName = _ref.objectName,
        moduleName = _ref.moduleName,
        btnIconCls = _ref.btnIconCls,
        btnText = _ref.btnText,
        menuItem1Text = _ref.menuItem1Text,
        menuItem2Text = _ref.menuItem2Text,
        menuItem3Text = _ref.menuItem3Text;

    var appManager = refs.appManager,
        uiManager = refs.uiManager,
        instanceManager = refs.instanceManager,
        sessionStorageManager = refs.sessionStorageManager,
        i18n = refs.i18nManager.get(),
        path = appManager.getPath(),
        config;

    if (isDefaultButton) {
        config = {
            text: btnText,
            iconCls: btnIconCls,
            toggleGroup: 'module',
            pressed: true,
            handler: function handler() {
                if (!this.pressed) {
                    this.toggle();
                }
            }
        };
    } else {
        config = {
            text: btnText,
            iconCls: btnIconCls,
            toggleGroup: 'module',
            menu: {},
            handler: function handler(b) {
                b.menu = Ext.create('Ext.menu.Menu', {
                    closeAction: 'destroy',
                    shadow: false,
                    showSeparator: false,
                    items: [{
                        text: menuItem1Text + '&nbsp;&nbsp;',
                        cls: 'ns-menu-item-noicon',
                        listeners: {
                            render: function render(b) {
                                this.getEl().dom.addEventListener('click', function (e) {
                                    if (!b.disabled) {
                                        uiManager.redirectCtrl(path + '/' + moduleName, e);
                                    }
                                });
                            }
                        }
                    }, '-', {
                        text: menuItem2Text + '&nbsp;&nbsp;',
                        cls: 'ns-menu-item-noicon',
                        disabled: !instanceManager.isStateCurrent(),
                        listeners: {
                            render: function render(b) {
                                this.getEl().dom.addEventListener('click', function (e) {
                                    if (!b.disabled) {
                                        var layout = instanceManager.getStateCurrent().toSession();
                                        layout.parentGraphMap = uiManager.get('treePanel').getParentGraphMap();

                                        sessionStorageManager.set(layout, 'analytical');

                                        if (sessionStorageManager.supported) {
                                            uiManager.redirectCtrl(path + '/' + moduleName + '/index.html?s=analytical', e);
                                        }
                                    }
                                });
                            }
                        }
                    }, {
                        text: menuItem3Text + '&nbsp;&nbsp;',
                        cls: 'ns-menu-item-noicon',
                        disabled: !sessionStorageManager.get(objectName),
                        listeners: {
                            render: function render(b) {
                                this.getEl().dom.addEventListener('click', function (e) {
                                    if (!b.disabled) {
                                        uiManager.redirectCtrl(path + '/' + moduleName + '/index.html?s=' + objectName, e);
                                    }
                                });
                            }
                        }
                    }],
                    listeners: {
                        show: function show() {
                            uiManager.setAnchorPosition(b.menu, b);
                        },
                        hide: function hide() {
                            b.menu.destroy();
                            uiManager.get('defaultIntegrationButton').toggle();
                        },
                        destroy: function destroy(m) {
                            b.menu = null;
                        }
                    }
                });

                b.menu.show();
            }
        };
    }

    return Ext.create('Ext.button.Button', config);
};
//# sourceMappingURL=IntegrationButton.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/IntegrationButton.js
 ** module id = 157
 ** module chunks = 0 1
 **/